import View from './View';

export { default as View, getIconLinkStyles } from './View';

export default View;
